<template>
    <div class="col-12 col-lg-9 mt-4 mt-lg-0">
        <div class="card">
            <div class="card-header">
                <h5>Open Invoices</h5>
            </div>
            <div class="card-divider"></div>
            <div class="card-table">
                <div class="table-responsive-md">
                    <table>
                        <thead>
                            <tr>
                                <th>Select</th>
                                <th>Invoice</th>
                                <th class="account-table-center">Type</th>
                                <th>O/E Customer</th>
                                <th>Ship From</th>
                                <th>Trn Date</th>
                                <th>Due Date</th>
                                <th>Orig Amt</th>
                                <th>Balance</th>												
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(inv, indx) in displayCurrPage" :key="indx">
                                <td><router-link :to="'/invoice/' + inv.RMLOC + '/' + inv.RMREFN"  class="btn btn-xs btn-primary">View</router-link></td>
                                <td class="account-table-center">{{inv.RMREFN}}</td>
                                <td class="account-table-center">{{inv.TRANTYPE}}</td>
                                <td class="account-table-center">{{inv.RMCUST}}</td>
                                <td class="account-table-center">{{inv.LCTAXC}}</td>
                                <td class="account-table-center">{{inv.TRNDATE}}</td>
                                <td class="account-table-center">{{inv.DUEDATE}}</td>
                                <td class="account-table-right">{{ twoDecimals(inv.RMAORG) }}</td>	
                                <td class="account-table-right">{{ twoDecimals(inv.RMAREM) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card-divider"></div>
            <div class="card-footer">
                <base-pagination
                    v-if="this.invoices.length > 0"
                    :perPage="perPage"
                    :pages="pages"
                    :currentPage="page"
                    @updatePage="updatePage"
                ></base-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";
import BasePagination from "../../base/BasePagination.vue";
import Price from '../../../mixins/price.js';

export default {
    components: {BasePagination},
    mixins: [Price],
    data() {
        return {
            page: 1,
            perPage: 20,
            pages: [],
            invoices: []
        }
    },
    computed: {
        displayCurrPage() {
            return this.paginate(this.invoices);
        },
    },

    methods: {
        paginate(invoices) {
            let page = this.page;
            let perPage = this.perPage;
            let from = page * perPage - perPage;
            let to = page * perPage;

            return invoices.slice(from, to);
        },

        total_items(total) {
            this.total_results = total;
            this.pages = [];
            let numberOfPages = Math.ceil(this.total_results / this.perPage);
            for (let index = 1; index <= numberOfPages; index++) {
                this.pages.push(index);
            }
        },

        getOpenInvoices() {
            this.invoices = [], 
            this.isloading = true;

            axiosvl.post(this.$store.getters['api/openinvoices_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            }).then((response) => {
                const lists = response.data.webroutine.lists;
                const RMLIST = lists.RMLIST;

                this.invoices = RMLIST.entries;
                this.total_items(this.invoices.length);
                this.isloading = false;
                // this.servermessages = messages;
            }).catch((error) => {
            this.isloading = false;
                console.error("error - " + error);
            });
        },

        updatePage(currentPage) {
            this.page = currentPage;
        },
    },

    created() {
        this.getOpenInvoices();
    }
}
</script>